import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Datetime from 'react-datetime'

import { LoadingSpinner } from '../../components'
import { fetchGradebookData, fetchSections, updateFilters } from '../actions'

import FilterFormLabel from './FilterFormLabel'
import FilterFormSections from './FilterFormSections'

const UNASSIGNED_SECTION_KEY = 'unassigned_section_key'
const DATE_FORMAT = 'YYYY-MM-DD HH:MM'

export class FilterForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      ...this.returnDefaultState(),
    }
  }

  static propTypes = {
    limit: PropTypes.number.isRequired,
    sections: PropTypes.array,
    updateFilters: PropTypes.func.isRequired,
    fetchSections: PropTypes.func.isRequired,
    fetchGradebookData: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.fetchSections()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      loading: false,
      selectedSections: [UNASSIGNED_SECTION_KEY, ...nextProps.sections],
    })
  }

  returnDefaultState() {
    return {
      lastName: '',
      firstName: '',
      signupDateStart: '',
      signupDateEnd: '',
      selectedSections: [],
      showClearButton: false,
    }
  }

  applyFilters = (showClearButton = true) => {
    const data = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      limit: this.props.limit,
    }

    if (this.state.signupDateStart) {
      data.signup_date_start = this.state.signupDateStart.format(DATE_FORMAT)
    }
    if (this.state.signupDateEnd) {
      data.signup_date_end = this.state.signupDateEnd.format(DATE_FORMAT)
    }

    let skipSections = this.props.sections.every(s =>
      this.state.selectedSections.includes(s)
    )
    if (!skipSections) {
      data.sections = this.state.selectedSections.join(',')
    }
    this.updateData(data, showClearButton)
  }

  updateData = (data, showClearButton) => {
    if (showClearButton) {
      this.setState({
        showClearButton,
      })
    }

    this.props.updateFilters(data)
    this.props.fetchGradebookData(data)
  }

  clearFilters = () => {
    this.setState(
      {
        ...this.returnDefaultState(),
        selectedSections: [UNASSIGNED_SECTION_KEY, ...this.props.sections],
      },
      () => {
        this.applyFilters(false)
      }
    )
  }

  handleTextChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleDateTimeChange = (component, value) => {
    this.setState({
      [component]: value,
    })
  }

  handleFormSubmit = e => {
    e.preventDefault()
    this.applyFilters()
  }

  handleSectionClicked = section => {
    let selectedSections = [...this.state.selectedSections]
    var i = selectedSections.indexOf(section)

    if (i === -1) {
      selectedSections.push(section)
    } else {
      selectedSections.splice(i, 1)
    }
    this.setState({
      selectedSections,
    })
  }

  handleAllSelectionClick = selectAll => {
    let selectedSections
    if (selectAll) {
      selectedSections = [UNASSIGNED_SECTION_KEY, ...this.props.sections]
    } else {
      selectedSections = []
    }
    this.setState({
      selectedSections,
    })
  }

  render() {
    const {
      loading,
      lastName,
      firstName,
      signupDateStart,
      signupDateEnd,
      selectedSections,
      showClearButton,
    } = this.state

    const { sections } = this.props

    if (loading) {
      return (
        <span className="form-container form-container-vertical">
          <div className="main spinner-holder">
            <LoadingSpinner style={{ fontSize: '50px' }} />
          </div>
        </span>
      )
    }

    return (
      <span className="form-container form-container-vertical">
        <form
          className="custom-form"
          onSubmit={this.handleFormSubmit}
          id="form"
        >
          <div className="form-response-message" />
          <div className="form-vertical form-fieldset-container">
            <FilterFormLabel htmlFor="lastName" labelText="Last Name Contains:">
              <input
                className="form-control"
                name="lastName"
                id="lastName"
                value={lastName}
                onChange={this.handleTextChange}
                type="text"
              />
            </FilterFormLabel>

            <FilterFormLabel
              htmlFor="firstName"
              labelText="First Name Contains:"
            >
              <input
                className="form-control"
                id="firstName"
                name="firstName"
                value={firstName}
                onChange={this.handleTextChange}
                type="text"
              />
            </FilterFormLabel>

            <div className="signupDate align-items-base d-flex justify-content-start flex-column flex-xl-row">
              <FilterFormLabel
                htmlFor="signup-date-from"
                labelText="Signup Date Start"
              >
                <Datetime
                  inputProps={{
                    className: 'form-control',
                    id: 'signup-date-from',
                    name: 'signupDateStart',
                    type: 'text',
                  }}
                  onChange={value =>
                    this.handleDateTimeChange('signupDateStart', value)
                  }
                  value={signupDateStart}
                  closeOnSelect
                />
              </FilterFormLabel>
              <div className="left-pad" />
              <FilterFormLabel
                htmlFor="signup-date-to"
                labelText="Signup Date End"
              >
                <Datetime
                  inputProps={{
                    className: 'form-control',
                    id: 'signup-date-to',
                    name: 'signupDateEnd',
                    type: 'text',
                  }}
                  onChange={value =>
                    this.handleDateTimeChange('signupDateEnd', value)
                  }
                  value={signupDateEnd}
                  closeOnSelect
                />
              </FilterFormLabel>
            </div>

            <FilterFormLabel
              id="multi-select-course-sections"
              htmlFor="course-sections"
              labelText="Course Section:"
            >
              <a
                onClick={() => this.handleAllSelectionClick(true)}
                className="mr-4"
              >
                Select All
              </a>
              <a onClick={() => this.handleAllSelectionClick(false)}>
                Unselect All
              </a>
              <FilterFormSections
                unassignedKey={UNASSIGNED_SECTION_KEY}
                handleSectionClicked={this.handleSectionClicked}
                checkedSections={selectedSections}
                allSections={sections}
              />
            </FilterFormLabel>

            <div className="form-div-submit form-submit-buttons justify-content-around d-flex">
              <input
                id="submit_button_form"
                name="submit_button"
                type="hidden"
                value=""
              />
              <button
                className="btn custom-form-submit-button btn-default btn-myed btn-default-myed"
                data-form-container-id="g15295527c81a2001x2"
                id="submit_button_form_0"
                tabIndex="0"
                type="submit"
              >
                Apply Filters
              </button>
              {showClearButton && (
                <button
                  id="clear-filters"
                  className="btn btn-default btn-myed btn-default-myed"
                  onClick={this.clearFilters}
                >
                  Reset
                </button>
              )}
            </div>
          </div>
        </form>
      </span>
    )
  }
}

const mapStateToProps = state => {
  return {
    limit: state.limit,
    sections: state.sections,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchGradebookData: data => {
      dispatch(fetchGradebookData(data))
    },
    updateFilters: data => {
      dispatch(updateFilters(data))
    },
    fetchSections: () => {
      dispatch(fetchSections())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterForm)
